import { render, staticRenderFns } from "./ChatControl.vue?vue&type=template&id=e21a472e&"
import script from "./ChatControl.vue?vue&type=script&lang=ts&"
export * from "./ChatControl.vue?vue&type=script&lang=ts&"
import style0 from "./ChatControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports